import React, { FunctionComponent } from 'react';
import { styled, Typography, TypographyProps } from '@mui/material';

import { StyledTableCell, StyledTableRow } from '../Table/type1/TableStyles';

interface TableNoDataProps {
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  title?: string;
  description?: string;
  imageProps?: React.HTMLAttributes<HTMLImageElement>;
  titleProps?: TypographyProps;
  descriptionProps?: TypographyProps;
}

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(8, 2),
}));

const TableNoData: FunctionComponent<TableNoDataProps> = ({
  containerProps = {},
  imageProps = {},
  title,
  description,
  titleProps = {},
  descriptionProps = {},
}) => {
  return (
    <StyledTableRow>
      <StyledTableCell colSpan={12} sx={{ borderBottom: 'none' }}>
        <RootStyle {...containerProps}>
          <div>
            <img
              src="https://assets.minimals.cc/public/assets/icons/empty/ic-content.svg"
              alt="empty"
              style={{ height: 240 }}
              {...imageProps}
            />

            {title ? (
              <Typography variant="h5" gutterBottom {...titleProps}>
                {title}
              </Typography>
            ) : null}

            {description ? (
              <Typography
                variant="body2"
                sx={{ color: 'text.secondary' }}
                {...descriptionProps}
              >
                {description}
              </Typography>
            ) : null}
          </div>
        </RootStyle>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default TableNoData;
